// Define your constants here
export const HTTP_REQUEST = {
    API_BASE_URL: process.env.VUE_APP_API_URL,
    API_KEY: '12345',
    VERSION: '0.1',
    DEFAULT_LANGUAGE: 'en',
    AUTH_TOKEN: 'Authorization'
};

export const LOCAL_STORAGE = {
    AuthToken: 'AuthToken',
    VenueId: 'VenueId',
    VenueProfile: 'VenueProfile'
};

export const ALL_EVENTS = {
    Url: 'events?PageSize=40&PageNumber=',
    Name: 'Alla evenemang',
    CacheName: 'eventsCache'
};

export const CUSTOM_ALL_EVENTS = {
    Url: 'events?PageSize=40&PageNumber=',
    Name: 'Custom Events',  // Give it a meaningful name, if necessary
    CacheName: 'customEventsCache'  // Provide a unique CacheName for custom events
};